import { HStack, Icon, Stack, Text } from '@genial/components';
import React from 'react';
import { Pressable } from 'react-native';

import { CustomerTableItemTypes } from '..';

export const IncomeTaxButton: React.FC<
  Omit<
    CustomerTableItemTypes.Props,
    'customerDetailNavigation' | 'customerDetailHref' | 'accountSelected' | 'setAccountSelected'
  >
> = ({ onDownloadIncomeStatementFile, customer, isExporting }) => {
  const irDate = customer.currentYearIncomeStatement;

  return (
    <Pressable onPress={() => onDownloadIncomeStatementFile(customer)} disabled={isExporting}>
      <HStack alignItems="center" space="stack.quarck">
        <Text
          display={{ base: 'flex', lg: 'none' }}
          color={isExporting ? 'neutral.light' : 'brand.tertiary.principal'}
          fontSize="md">{`IR ${irDate}`}</Text>
        <Text
          display={{ base: 'none', lg: 'flex' }}
          fontSize="md"
          {...(isExporting && { color: 'neutral.light' })}>
          {irDate}
        </Text>
        <Icon
          testID="customers-table-item-desktop-tax-income-icon"
          name="Pdf"
          size="xs"
          color={isExporting ? 'neutral.light' : 'brand.tertiary.principal'}
        />
      </HStack>
    </Pressable>
  );
};

export const IncomeTaxButtonLoading: React.FC = () => {
  return (
    <Pressable disabled>
      <HStack alignItems="center" space="stack.quarck">
        <Stack w="inline.xs">
          <Text isLoading />
        </Stack>
        <Icon
          testID="customers-table-item-desktop-tax-income-icon"
          name="Pdf"
          size="xs"
          color="neutral.light"
        />
      </HStack>
    </Pressable>
  );
};
